import { api } from "../base";
import type { TalosSideConvention } from "@pulse-ui/codegen-v2/generated_ts/venues/talos";

// Served by trading-ops-server GET /api/trading-ops/v1/halo-defaults.
export interface IHaloDefaults {
  risk_subaccount?: string;
  lender?: string;
  loan_lender_account_filter?: string[];
  // Absent only on a server that predates this field; "house" means the options booking
  // side field is the house side at Talos, "customer" flips it to the customer's side.
  options_side_convention?: `${TalosSideConvention}`;
  // Which WebSocket the deal stream opens; absent on a server that predates it, read as talos.
  options_deal_stream_source?: OptionsDealStreamSource;
}

export type OptionsDealStreamSource = "talos" | "store";

const haloDefaultsEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getHaloDefaults: build.query<IHaloDefaults, void>({
      query: () => ({
        url: "/api/trading-ops/v1/halo-defaults",
      }),
      providesTags: ["HaloDefaults"],
    }),
  }),
});

export const { useGetHaloDefaultsQuery } = haloDefaultsEndpoints;
